import { render } from "./MyBenefitAnalysis.vue?vue&type=template&id=3d6027c2"
import script from "./MyBenefitAnalysis.vue?vue&type=script&lang=js"
export * from "./MyBenefitAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__